import { render, staticRenderFns } from "./PersonalQuestionTile.vue?vue&type=template&id=4dbb5e6a&scoped=true"
import script from "./PersonalQuestionTile.vue?vue&type=script&lang=js"
export * from "./PersonalQuestionTile.vue?vue&type=script&lang=js"
import style0 from "./PersonalQuestionTile.vue?vue&type=style&index=0&id=4dbb5e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb5e6a",
  null
  
)

export default component.exports